import { SelectedAvailabilityParams } from 'state/availability';
import { dashboard } from 'types';
import AppConstants from 'constants/AppConstants';
import dashboardProtos from 'utils/protos';

const {
  CalendarAvailabilityRequest,
  CalendarAvailabilityRemoveRequest,
  CalendarBlockUpdateRequest,
} = dashboardProtos;

export function fetchAvailability(options: {
  date: string;
  selectedPurchaseId?: number;
  tableId?: number[];
  turnTime?: number;
}): ApiAction {
  const { date, selectedPurchaseId, tableId, turnTime } = options;
  const actualRequest = {
    startDate: date,
    endDate: date,
    excludePurchaseId: selectedPurchaseId ? [selectedPurchaseId] : [],
    filterTableId: tableId,
    turnTimeOverride: turnTime,
  };

  return {
    TockApi: {
      postProto: '/dashboard/calendar/availability',
      type: AppConstants.AVAILABILITY_FETCH,
      request: CalendarAvailabilityRequest.fromObject(actualRequest),
    },
  };
}

export function removeAvailability(businessDay: string, tableId: number[]): ApiAction {
  const actualRequest = {
    businessDay,
    tableId,
  };

  return {
    TockApi: {
      postProto: '/dashboard/calendar/availability/remove',
      type: AppConstants.NULL,
      request: CalendarAvailabilityRemoveRequest.fromObject(actualRequest),
    },
  };
}

export type AvailabilityParams = Partial<SelectedAvailabilityParams>;

export function setSelectedParams(request: AvailabilityParams): BaseTockAction {
  return {
    type: AppConstants.AVAILABILITY_SET_PARAMS,
    payload: request,
  };
}

export function openAvailabilityPanel() {
  return {
    type: AppConstants.UI_AVAILABILITY_PANEL_SHOW,
  };
}

export function closeAvailabilityPanel() {
  return {
    type: AppConstants.UI_AVAILABILITY_PANEL_HIDE,
  };
}

export function showAvailabilityDrawer() {
  return {
    type: AppConstants.UI_AVAILABILITY_DRAWER_SHOW,
  };
}

export function hideAvailabilityDrawer() {
  return {
    type: AppConstants.UI_AVAILABILITY_DRAWER_HIDE,
  };
}

export function openAvailabilityFilters() {
  return {
    type: AppConstants.UI_AVAILABILITY_FILTERS_SHOW,
  };
}

export function closeAvailabilityFilters() {
  return {
    type: AppConstants.UI_AVAILABILITY_FILTERS_HIDE,
  };
}

export function clearAvailabilityParams() {
  return {
    type: AppConstants.UI_AVAILABILITY_CLEAR_PARAMS,
  };
}

export type AvailabilityMode = 'DEFAULT' | 'RESCHEDULE' | 'ASSIGN_TABLE';

export function setMode(mode: AvailabilityMode, selectedPurchaseId?: number): BaseTockAction {
  return {
    type: AppConstants.AVAILABILITY_SET_MODE,
    payload: {
      mode,
      selectedPurchaseId,
    },
  };
}

export function updateBlocks(request: dashboard.ICalendarBlockUpdateRequest): ApiAction {
  return {
    TockApi: {
      postProto: '/dashboard/calendar/block/update',
      type: AppConstants.NULL,
      request: CalendarBlockUpdateRequest.fromObject(request),
    },
  };
}
